import $ from "jquery";

$(() => {
  const forms = $("form.inquiry-form");
  if (forms.length > 0) {
    forms.each((i, form) => {
      const formEl = $(form);
      const formContainer = formEl.parent('div.wpcf7[role="form"]');
      const messageContainer = formContainer.siblings(
        ".post-submission-message"
      );
      const redirect = formContainer
        .find("input[type='hidden'][name='redirect']")
        .attr("value");

      formEl.on("wpcf7mailsent", () => {
        if (redirect) {
          window.location.href = redirect;
        }
        if (!redirect) {
          formContainer.hide();
          messageContainer.show();
        }
      });
      messageContainer.find("button.reset").on("click", () => {
        formContainer.show();
        messageContainer.hide();
      });
    });
  }
});
